import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { triggerHaptic } from "@/lib/haptics";

interface BookingModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const BookingModal = ({ open, onOpenChange }: BookingModalProps) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (open && typeof window !== "undefined") {
      // Trigger medium haptic feedback when opening booking modal
      triggerHaptic('medium');
      
      // Load HubSpot Meetings Embed script
      const script = document.createElement("script");
      script.src = "https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js";
      script.async = true;
      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[600px] max-h-[90vh] overflow-y-auto p-0">
        <DialogHeader className="p-6 pb-4">
          <DialogTitle className="text-2xl font-bold">
            {t('booking.title')}
          </DialogTitle>
        </DialogHeader>
        
        <div className="w-full px-6 pb-6">
          {/* HubSpot Meeting Embed Container */}
          <div 
            className="meetings-iframe-container" 
            data-src="https://meet.guestlyhomes.com/meetings/jacob-granberg/mote-med-guestly?embed=true"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default BookingModal;
